export const environment = {
  production: true
};



// WEBPACK FOOTER //
// /Users/ColeMarsteller/learn-js/Mehtris/src/environments/environment.ts